<template>
  <div class="d-flex grow justify-space-between">
    <span
      class="title--heading"
    >
      {{ this.themeTitle }}
    </span>
    <span
      class="theme--button"
    >
      <v-switch
        @change="switchTheme"
        v-model="darkMode"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: "ThemeSwitch",
  data() {
    return {
      darkMode: false
    }
  },
  props: {
    themeTitle: {
      type: String,
      default: ""
    },
    storeAs: {
      type: String,
      default: 'theme'
    }
  },
  created() {
    let theme = false;
    if (localStorage) {
      theme = localStorage.getItem(this.storeAs);
      if (theme == "true") {
        this.darkMode = true;
        this.$vuetify.theme.dark = true;
      }
    }
  },
  methods: {
    switchTheme() {
      let darkTheme = this.darkMode;
      this.$vuetify.theme.dark = darkTheme;
      if (localStorage) {
        localStorage.setItem(this.storeAs, darkTheme);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title--heading {
  align-self: center;
}

.v-input--selection-controls {
  padding-top: 0;
}
</style>
